import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7dc844e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "success-box",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "message" }
const _hoisted_3 = { class: "contain-buttons" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Ok ")
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "success-box__box",
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.message), 1),
      _createElementVNode("span", _hoisted_3, [
        _withDirectives(_createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.continueAction && _ctx.continueAction(...args))),
          class: "link"
        }, _hoisted_5, 512), [
          [_directive_focus]
        ])
      ])
    ])
  ]))
}